import type { SettlementEvent as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

/**
 * An event a settlement is or can be based on. `SettlementConfig.vue` renders the start time, the
 * door time and the timezone, and nothing else, so nothing else is selected -- not AppSchema's
 * `name` or `state`, and not `date`.
 *
 * `date` is the one worth naming, because the legacy query did carry it. It is not merely unread:
 * it no longer means the same thing. `App::Settlement::SettlementEventType#date` is
 * `read_attribute(:date)`, where the legacy `Types::EventType#date` calls `Event#date`, which
 * derives the date from `start_timestamp` in the event's timezone whenever that column is set.
 * Selecting it would hand the next reader a subtly different value under a familiar name.
 */
export type SettlementEvent = {
  id: number;
  startTime?: string;
  doorTime?: string;
  endTime?: string;
  timezone?: string;
};

export const fromGql = (item: GQLItem): SettlementEvent =>
  take(item, 'id', 'startTime', 'doorTime', 'endTime', 'timezone');
